import { action, createRequestTypes } from '../base';

export const reportV2ActionTypes = {
  GET_REPORTS_LIST_V2: createRequestTypes('GET_REPORTS_LIST_V2'),
  FILTER_REPORTS_LIST_V2: createRequestTypes('FILTER_REPORTS_LIST_V2'),
  GET_REPORTS_LIST_V2_DETAIL: createRequestTypes('GET_REPORTS_LIST_V2_DETAIL'),
  DELETE_SCHEDULED_REPORT: createRequestTypes('DELETE_SCHEDULED_REPORT'),
  GET_REPORTS_BY_ID: createRequestTypes('GET_REPORTS_BY_ID'),
};

class ReportV2Actions {

  /**
   *
   * @param params
   * @param callback
   * @returns {{type: *}}
   */
  getReportsV2List = (params, callback) => action(reportV2ActionTypes.GET_REPORTS_LIST_V2.REQUEST, {
    params,
    callback,
  });

  /**
   *
   * @param getReportsV2ListLoading
   * @returns {{type: *}}
   */
  getReportsV2ListLoading = (getReportsV2ListLoading) => action(reportV2ActionTypes.GET_REPORTS_LIST_V2.LOADING, {
    getReportsV2ListLoading,
  })

  /**
   *
   * @param reportsV2ListData
   * @returns {{type: *}}
   */
  getReportsV2ListSuccess = (reportsV2ListData) => action(reportV2ActionTypes.GET_REPORTS_LIST_V2.SUCCESS, {
    reportsV2ListData,
  })

  /**
   *
   * @param params
   * @param callback
   * @returns {{type: *}}
   */
  filterReportsV2List = (params, callback) => action(reportV2ActionTypes.FILTER_REPORTS_LIST_V2.REQUEST, {
    params,
    callback,
  });

  /**
   *
   * @param filterReportsV2ListLoading
   * @returns {{type: *}}
   */
  filterReportsV2ListLoading = (filterReportsV2ListLoading) => action(reportV2ActionTypes.FILTER_REPORTS_LIST_V2.LOADING, {
    filterReportsV2ListLoading,
  })

  /**
   *
   * @param params
   * @param callback
   * @returns {{type: *}}
   */
  getReportsV2ListDetail = (params, callback) => action(reportV2ActionTypes.GET_REPORTS_LIST_V2_DETAIL.REQUEST, {
    params,
    callback,
  });

  /**
   *
   * @param getReportsV2ListDetailLoading
   * @returns {{type: *}}
   */
  getReportsV2ListDetailLoading = (getReportsV2ListDetailLoading) => action(reportV2ActionTypes.GET_REPORTS_LIST_V2_DETAIL.LOADING, {
    getReportsV2ListDetailLoading,
  })

  /**
   *
   * @param reportsV2ListDetailData
   * @returns {{type: *}}
   */
  getReportsV2ListDetailSuccess = (reportsV2ListDetailData) => action(reportV2ActionTypes.GET_REPORTS_LIST_V2_DETAIL.SUCCESS, {
    reportsV2ListDetailData,
  })

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  deleteScheduledReport = (payload, callback) => action(reportV2ActionTypes.DELETE_SCHEDULED_REPORT.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param deleteScheduledReportLoading
   * @returns {{type: *}}
   */
  deleteScheduledReportLoading = (deleteScheduledReportLoading) => action(reportV2ActionTypes.DELETE_SCHEDULED_REPORT.LOADING, {
    deleteScheduledReportLoading,
  })

  getReportsById = (params, callback) => action(reportV2ActionTypes.GET_REPORTS_BY_ID.REQUEST, {
    params,
    callback,
  });

  /**
   *
   * @param getReportsV2ListLoading
   * @returns {{type: *}}
   */
  getReportsByIdLoading = (getReportsByIdLoading) => action(reportV2ActionTypes.GET_REPORTS_BY_ID.LOADING, {
    getReportsByIdLoading,
  })

  /**
   *
   * @param reportsV2ListData
   * @returns {{type: *}}
   */
  getReportsByIdSuccess = (reportData) => action(reportV2ActionTypes.GET_REPORTS_BY_ID.SUCCESS, {
    reportData,
  })
}

export default new ReportV2Actions();
